<script>
    import { token } from "./store/token.js";
    import { fly } from "svelte/transition";

    export let show = false;
    export let user_id = "";
    export let email = "xx";

    var workspace_id = "";
    var project_id = "";
    var notification_title = "";
    var notification_subtitle = "";
    var notification_text = "";

    let button_disabled = false;
    let message = "";

    var ENV_SELECT = {
        //staging: `https://staging.api.control.vollume.com/admin/push/send`,
        staging: `${process.env.API_ROOT}/admin/push/send`,
        workspace_staging: `${process.env.API_ROOT}/admin/push/send`,
        localhost: `http://localhost:1337/admin/push/send`,
    };

    const send_push_notification = async () => {
        const headers_object = {
            Authorization: "Bearer " + $token,
        };

        console.log(workspace_id ? ENV_SELECT.workspace_staging : ENV_SELECT.staging)

        const response = await fetch(
            workspace_id ? ENV_SELECT.workspace_staging : ENV_SELECT.staging,
            //`https://staging.api.control.vollume.com/admin/push/send`,
            //ENV_SELECT.localhost,
            {
                headers: headers_object,
                method: "post",
                body: JSON.stringify({
                    workspace_id,
                    project_id,
                    user_id,
                    notification_title,
                    notification_subtitle,
                    notification_text,
                }),
            }
        );
        const json = await response.json();
        message = json.message;

        setTimeout(() => {
            message = "";
            button_disabled = false;
        }, 3000);
        return json;
    };
</script>

{#if show}
    <nav transition:fly={{ x: 500, opacity: 1 }}>
        <button on:click={() => (show = !show)}>Close</button>
        <br />
        <br />
        <input
            bind:value={workspace_id}
            style="width:100%"
            placeholder="Workspace ID (optional)"
        />
        <input
            bind:value={project_id}
            style="width:100%"
            placeholder="Project ID (optional)"
        />
        <br />
        <br />
        <input
            bind:value={notification_title}
            style="width:100%"
            placeholder="Push notification title"
        />
        <input
            bind:value={notification_subtitle}
            style="width:100%"
            placeholder="Push notification subtitle (optional)"
        />
        <input
            bind:value={notification_text}
            style="width:100%"
            placeholder="Push notification text"
        />
        <br />
        <br />
        <button
            on:click={() => {
                var result = confirm(
                    "Do you really want to send push notification to " +
                        email +
                        "?"
                );

                if (!result) {
                    return;
                }

                button_disabled = true;
                send_push_notification();
            }}
            disabled={button_disabled}>Send push notification to {email}</button
        >

        <br />
        <br />

        <div>
            {message}
        </div>
    </nav>
{/if}

<style>
    nav {
        position: fixed;
        top: 0;
        right: 0;
        height: 100%;
        padding: 2rem 1rem 0.6rem;
        border-left: 1px solid #aaa;
        background: #fff;
        overflow-y: auto;
        width: 500px;
    }
</style>
